import { z } from 'zod';

export const MeasureUnitSchema = z.object({
  id: z.string().or(z.number()), 
  name: z
    .string()
    .min(1, 'Название обязательно для заполнения')
    .max(100, 'Название не должно превышать 100 символов'),
  description: z
    .string()
    .max(300, 'Описание не должно превышать 300 символов')
    .optional()
    .or(z.literal('')),
  shortName: z
    .string()
    .min(1, 'Короткое название обязательно для заполнения')
    .max(7, 'Короткое название не должно превышать 7 символов'),
});
